const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent

export default !!(typeof navigator !== 'undefined' &&
  navigator.vendor?.includes('Apple') &&
  userAgent &&
  !userAgent.includes('CriOS') &&
  !userAgent.includes('FxiOS'))
